import { Routes, Route } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { AuthProvider } from '@/contexts/AuthContext'
import { ThemeProvider } from '@/components/ThemeProvider'

// Pages
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { KnowledgeBasesPage } from '@/pages/KnowledgeBasesPage'
import { KnowledgeBasePage } from '@/pages/KnowledgeBasePage'
import { KnowledgeBaseDataPage } from '@/pages/KnowledgeBaseDataPage'
import { AgentsManagementPage } from '@/pages/AgentsManagementPage'
import { ArtifactsPage } from '@/pages/ArtifactsPage'
import { UsersPage } from '@/pages/UsersPage'
import { UserDetailPage } from '@/pages/UserDetailPage'
import { PlatformSettingsPage } from '@/pages/PlatformSettingsPage'
import { AnalyticsPage } from '@/pages/AnalyticsPage'
import { CreditTrackingPage } from '@/pages/CreditTrackingPage'
import ServiceDefinitionsPage from '@/pages/ServiceDefinitionsPage'
import MailingListPage from '@/pages/MailingListPage'
import { ConsentPoliciesPage } from '@/pages/ConsentPoliciesPage'
import DebugPage from '@/pages/DebugPage'
import WorkflowsPage from '@/pages/WorkflowsPage'
import WorkflowEditorPage from '@/pages/WorkflowEditorPage'

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="admin-ui-theme">
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<DashboardPage />} />
            <Route path="knowledge-bases" element={<KnowledgeBasesPage />} />
            <Route path="knowledge-bases/:id" element={<KnowledgeBasePage />} />
            <Route path="knowledge-bases/:id/data" element={<KnowledgeBaseDataPage />} />
            <Route path="agents" element={<AgentsManagementPage />} />
            <Route path="artifacts" element={<ArtifactsPage />} />
            <Route path="artifacts/instances" element={<ArtifactsPage />} />
            <Route path="artifacts/instances/:artifactId" element={<ArtifactsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailPage />} />
            <Route path="mailing-list" element={<MailingListPage />} />
            <Route path="platform-settings" element={<PlatformSettingsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="credit-tracking" element={<CreditTrackingPage />} />
            <Route path="service-definitions" element={<ServiceDefinitionsPage />} />
            <Route path="consent-policies" element={<ConsentPoliciesPage />} />
            <Route path="workflows" element={<WorkflowsPage />} />
            <Route path="workflows/new" element={<WorkflowEditorPage />} />
            <Route path="workflows/:id/edit" element={<WorkflowEditorPage />} />
            <Route path="debug" element={<DebugPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
